/* eslint-disable import/prefer-default-export */
import { ChartConfig } from '../types'

export const isNetSentiment = (chartConfig: ChartConfig) => chartConfig.category === 'NetSentiment'
